import React, {
  ReactElement,
  useRef,
  useEffect,
  useState,
  ForwardedRef,
  cloneElement,
} from 'react';
import MuiTooltip, {
  TooltipProps as MuiTooltipProps,
} from '@material-ui/core/Tooltip';
import { useStyles } from './styles';

export interface TooltipProps extends MuiTooltipProps {
  children: ReactElement;
  maxWidth?: number;
}

export const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>(
  ({ children, maxWidth, ...props }, ref: ForwardedRef<HTMLDivElement>) => {
    const classes = useStyles({ maxWidth });

    const [isAnchorVisible, setIsAnchorVisible] = useState(true);
    const anchorRef = useRef<HTMLElement | null>(null);

    useEffect(() => {
      if (!anchorRef.current) return;
      const observer = new window.IntersectionObserver(
        ([entry]) => {
          setIsAnchorVisible(entry.isIntersecting);
        },
        {
          root: null,
          threshold: 0.01,
        }
      );
      observer.observe(anchorRef.current);

      // eslint-disable-next-line consistent-return
      return () => {
        observer.disconnect();
      };
    }, [anchorRef.current]);

    const childWithRef = cloneElement(children, { ref: anchorRef });

    if (!isAnchorVisible) {
      return childWithRef;
    }

    return (
      <MuiTooltip
        ref={ref}
        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
        {...props}
      >
        {childWithRef}
      </MuiTooltip>
    );
  }
);
